import { ref, watch } from 'vue';
const STORAGE_KEY = 'botc-app-data';
const defaultStoredData = {
    selectedLanguage: 'de',
    lastUpdated: Date.now(),
};
const storedData = ref(loadStoredData());
/**
 * Lade gespeicherte Daten aus LocalStorage
 */
function loadStoredData() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
    }
    catch (error) {
        console.error('Fehler beim Laden der Daten:', error);
    }
    return { ...defaultStoredData };
}
/**
 * Speichere Daten in LocalStorage
 */
function saveStoredData() {
    try {
        storedData.value.lastUpdated = Date.now();
        localStorage.setItem(STORAGE_KEY, JSON.stringify(storedData.value));
    }
    catch (error) {
        console.error('Fehler beim Speichern der Daten:', error);
    }
}
/**
 * Setze Game State zurueck
 */
function resetGameState() {
    storedData.value.gameState = undefined;
    saveStoredData();
}
/**
 * Initialisiere Game State wenn nicht vorhanden
 */
function initializeGameState() {
    if (!storedData.value.gameState) {
        storedData.value.gameState = {
            currentDay: 1,
            isNight: false,
            players: [],
            notes: [],
        };
        saveStoredData();
    }
    return storedData.value.gameState;
}
// Auto-save bei Aenderungen
watch(storedData, () => {
    saveStoredData();
}, { deep: true });
export function useStorage() {
    return {
        storedData,
        saveStoredData,
        resetGameState,
        initializeGameState,
    };
}
